import { PERMISSIONS } from '@core/constants/permissions.constants';
import { ReportConfig } from './sparepart-report.config';

export const EQUIPMENT_TAT_REPORT_CONFIG: ReportConfig = {
  id: 'equipment-tat',
  title: 'Equipment TAT Report',
   permissions: {
      view: PERMISSIONS.GSE.REPORTS.EQUIPMENT_TAT.VIEW,
      export: PERMISSIONS.GSE.REPORTS.EQUIPMENT_TAT.EXPORT,
    },
  filters: [
    {
      type: 'text',
      field: 'search',
      label: 'Search',
      placeholder: 'Search'
    },
    {
      type: 'date-range',
      field: 'dateRange',
      label: 'Date Range',
      placeholder: 'date range'
    },
    {
      type: 'dropdown',
      field: 'manufacturer',
      label: 'Manufacturer',
      placeholder: 'manufacturer',
      width: 'lg',
    },
    {
      type: 'dropdown',
      field: 'equipmentModel',
      label: 'Model',
      placeholder: 'model',
      width: 'lg',
    },
    {
      type: 'dropdown',
      field: 'equipmentId',
      label: 'Equipment ID',
      placeholder: 'equipment ID',
      multiselect: true,
      width: 'lg',
    },
  ],

  columns: [
    {
      field: 'startDate',
      header: 'Start Date',
      type: 'text',
      pipes: ['date'],
      width: '10%',
    },
    {
      field: 'endDate',
      header: 'End Date',
      type: 'text',
      pipes: ['date'],
      width: '10%',
    },
    {
      field: 'manufacturer',
      header: 'Manufacturer',
      type: 'text',
      width: '12%',
    },
    {
      field: 'equipmentId',
      header: 'Equipment ID',
      type: 'text',
      width: '12%',
    },
    {
      field: 'model',
      header: 'Model',
      type: 'text',
      width: '10%',
    },
    {
      field: 'serviceType',
      header: 'Service Type',
      type: 'text',
      pipes: ['replaceUnderscore', 'titlecase', 'formatServiceability', 'formatStatus'],
      width: '16%',
    },
    {
      field: 'idleTime',
      header: 'Idle Time (hr)',
      type: 'number',
      pipes: ['secondsToHoursMinutes'],
      width: '14%',
    },
    {
      field: 'technicians',
      header: 'Technicians',
      type: 'text',
      width: '16%',
    },
  ],
};